import { render, staticRenderFns } from "./PefListPage.vue?vue&type=template&id=0fd24a0c&"
import script from "./PefListPage.vue?vue&type=script&lang=js&"
export * from "./PefListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports